export default "/static/images/build_base_1.png?4477b6005b48a7f848df6fe33cf2747d";